import { Close, Description } from "@mui/icons-material";
import {
    Autocomplete,
    Avatar,
    Box,
    Chip,
    Divider,
    Drawer,
    Grid,
    IconButton,
    Link,
    TextField,
    Typography,
} from "@mui/material";
import MDButton from "components/MDButton";

export default function RightDrawer({
    open,
    onClose,
    data,
    employeeOptions,
    editableRowIndex,
    editedData,
    handleFieldChange,
    advertisements,
    getPositionLabel,
    handleAutocomplete,
}) {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: { width: 350, p: 3, margin: "0 !important", height: "100%", borderRadius: 0, boxShadow: 3 },
            }}
        >
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" fontWeight="bold">Employee Details</Typography>
                <IconButton onClick={onClose}>
                    <Close />
                </IconButton>
            </Box>

            <Divider sx={{ mb: 2 }} />

            {/* Profile Section */}
            {data && (
                <Box display="flex" alignItems="center" gap={2} mb={3}>
                    <Avatar alt={data.full_name} sx={{ width: 72, height: 72 }} />
                    <Box>
                        <Typography variant="h6" fontWeight="bold">{data.full_name}</Typography>
                        <Typography variant="body2" color="text.secondary">{data.email}</Typography>
                        <Typography variant="body2" color="text.secondary">{data.mobile}</Typography>
                    </Box>
                </Box>
            )}

            <Divider sx={{ mb: 2 }} />

            {/* Experience & Source Section */}
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Typography variant="body2" fontWeight="bold">Experience:</Typography>
                    <Chip label={`${data.experience} years`} color="primary" variant="outlined" sx={{ mt: 1 }} />
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" fontWeight="bold">Source:</Typography>
                    <Chip label={data.source} color="secondary" variant="outlined" sx={{ mt: 1 }} />
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" fontWeight="bold">Status:</Typography>
                    <Chip label={data.status === 4 ? "Rejected" : "Active"} color="error" variant="outlined" sx={{ mt: 1 }} />
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" fontWeight="bold">Recruiter ID:</Typography>
                    <Chip
                        label={
                            employeeOptions.find((option) => option.value == data.recruiter)?.label || "Unknown"
                        }
                        color="info"
                        variant="outlined"
                        sx={{ mt: 1 }}
                    />                </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            {/* Resume Link */}
            {data.cv && (
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <Description color="primary" />
                    <Link href={data.cv} target="_blank" rel="noopener" variant="body2">
                        View Resume
                    </Link>
                </Box>
            )}

            {/* Recruiter Autocomplete */}
            <Autocomplete
                id="recruiter"
                options={employeeOptions}
                getOptionLabel={(option) => option.label}
                value={
                    editedData[editableRowIndex]?.recruiter
                        ? employeeOptions.find(
                            (option) => option.value == editedData[editableRowIndex]?.recruiter
                        )
                        : null
                }
                fullWidth
                onChange={(event, newValue) => {
                    if (newValue) {
                        const selectedValues = Array.isArray(newValue)
                            ? newValue.map((v) => v.value)
                            : newValue.value;
                        handleFieldChange({ target: { value: selectedValues } }, "recruiter");
                    }
                }}
                renderInput={(params) => (
                    <TextField {...params} fullWidth name='recruiter' label="Recruiter" variant="standard" sx={{ mb: 2 }} />
                )}
            />

            {/* Job Openings Autocomplete */}
            <Autocomplete
                name="jd"
                options={advertisements.map((advertisement) => advertisement.position)}
                value={getPositionLabel(editedData[editableRowIndex]?.job_ad)}
                fullWidth
                onChange={(event, value) => handleAutocomplete(value)}
                renderInput={(params) => (
                    <TextField {...params} fullWidth label="Job Openings" variant="standard" sx={{ mb: 3 }} />
                )}
            />

            {/* Action Buttons */}
            <Box display="flex" justifyContent="space-between" mt={2}>
                <MDButton size='small' variant="contained" color="error">Reject</MDButton>
                <MDButton size='small' variant="contained" color="primary">Convert to Candidate</MDButton>
            </Box>
        </Drawer>
    );
}
